export default __webpack_public_path__ + "static/media/9.47a63745.png";